import { Container, Stack } from "@mantine/core";
import { SystemEmailsHeader } from "../../components/admin/system-emails/SystemEmailsHeader";
import { SystemEmailsTabs } from "../../components/admin/system-emails/SystemEmailsTabs";
import { useSystemEmailsTab } from "../../hooks/admin/useSystemEmailsPage";

export default function SystemEmailsPage() {
  const tab = useSystemEmailsTab();
  return (
    <Container fluid py="xl">
      <Stack gap="lg">
        <SystemEmailsHeader />
        <SystemEmailsTabs active={tab.active} onChange={tab.change} />
      </Stack>
    </Container>
  );
}
